import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { mapStateToProps, mapDispatchToProps } from '../Store';

const PromotionDropdown = ({ label, id, name, className, selected, changeHandler, actions, promotions, placeholder = 'Select Promotion' }) => {
    useEffect(() => {
        if (promotions?.promotions?.length === 0) {
            actions.promotionsActions.getPromotions();
        }
    }, []);

    return (
        <div className={`form-group ${className}`}>
            <label htmlFor={id} className='input-label'>
                {label}
            </label>
            <select name={name} id={id} className='form-control text-uppercase' onChange={changeHandler} value={selected}>
                {placeholder && <option value='0'>{placeholder}</option>}
                {promotions?.promotions?.map(({ id, title }, idx) => (
                    <option value={id} key={idx}>
                        {title}
                    </option>
                ))}
            </select>
        </div>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(PromotionDropdown);
